import { createAction } from '@reduxjs/toolkit'

export const RECORD_FILTERS = 'record_filters'

export const recordFilters = createAction<{}>(RECORD_FILTERS)
